import LOGO from "../images/Cerveceras.png";

export const Team__Cerveceras = {
  name: "Cerveceras",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#EF4444",
  teamJerseyColor: "#111111",

  // Stats
  gamesWon: 3,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,


  // ownGoalsInFavor: 20 + 40 + 34 + 30,
  // goalsScoredAgainst: 0 + 29 + 16 + 52,
  ownGoalsInFavor: 20 + 30,
  goalsScoredAgainst: 0 + 52,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
